import { types } from "mobx-state-tree"

export const DoctorDepartment = types
    .model({
        departmentId: types.optional(types.number, 0),
        departmanName: types.optional(types.string, "")
    }).actions(self => ({

    }))